import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zh from './zh.json';
import ja from './ja.json';
import vi from './vi.json';
import es from './es.json';
import pt from './pt.json';
import { getLocales } from 'react-native-localize';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { updateTranslations } from './string_res';
import { updateIosLaunage } from '../AppEvent';
import globalEventBus from '../utils/EventBus';
import { Platform } from 'react-native';

const resources = {
	en: {
		translation: en,
	},
	zh: {
		translation: zh,
	},
	ja: {
		translation: ja,
	},
	vi: {
		translation: vi,
	},
	es: {
		translation: es,
	},
	pt: {
		translation: pt,
	},
};

// 安全获取系统语言
let systemLanguage = 'en';
try {
	const locales = getLocales();
	systemLanguage = locales?.[0]?.languageCode || 'en';
} catch (e) {
	console.warn('[i18n] Failed to get locales, using default: en', e);
	systemLanguage = 'en';
}

function checkLanguage() {
	if (!systemLanguage || typeof systemLanguage !== 'string') {
		return false;
	}
	return (
		systemLanguage.includes('zh') ||
		systemLanguage.includes('en') ||
		systemLanguage.includes('vi') ||
		systemLanguage.includes('ja') ||
		systemLanguage.includes('es') ||
		systemLanguage.includes('pt')
	);
}

const currentLocale = checkLanguage() ? systemLanguage : 'en';
const Language = {
	curLanguage: currentLocale,
};
export const setInitialLanguage = async () => {
	const storedLanguage = await AsyncStorage.getItem('userLanguage');
	if (storedLanguage) {
		// 如果用户之前选择了语言，则直接使用
		changeLanguage(storedLanguage);
		Language.curLanguage = storedLanguage;
	} else {
		updateIosLaunage(currentLocale);
	}
};

// 手动切换语言的函数
export const changeLanguage = (language: string) => {
	i18n.changeLanguage(language).then(() => {
		updateIosLaunage(language);
		Language.curLanguage = language;
		updateTranslations();
		AsyncStorage.setItem('userLanguage', language).then();
		globalEventBus.emit('languageChanged', language);
	});
};

export const getLanguage = () => Language.curLanguage;

i18n
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'en', // 当无法检测到语言时，默认使用的语言
		lng: Language.curLanguage,
		compatibilityJSON: 'v3',
		debug: __DEV__,
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	})
	.then();

export default i18n;
